<template>
  <div v-if="purchase && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="purchase" />
  </div>
</template>
<script>
import Purchases from "@/api/purchases";

import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    purchase: {},
  }),

  mounted() {
    PrintTemplates.fetchOne("adminPurchase").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          Purchases.purchasePrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.purchase = response.data.purchase;
                this.purchase.purchase_details =
                  this.purchase.purchase_details.map((detail) => {
                    if (detail.negotiate_price_flg == 1) {
                      // 显示后议价
                      // 单价
                      detail.price = this.$t(
                        "PurchasesDetail.purchaseFields.negotiatePrices"
                      );
                      // 采购金额
                      detail.total = this.$t(
                        "PurchasesDetail.purchaseFields.negotiatePrices"
                      );
                    }
                    return detail;
                  });
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>